import { graphql } from "@/gql";

export const proDriverCountQuery = graphql(`
  query ProDriverCount(
    $radiusAround: RadiusAround
    $excludeJobOpeningId: ID
    $archived: Boolean
  ) {
    proDrivers(
      first: 1
      radiusAround: $radiusAround
      excludeJobOpeningId: $excludeJobOpeningId
      archived: $archived
    ) {
      paginatorInfo {
        total
      }
    }
  }
`);
